<div class="body">
  <div class="description">
    <ui-skeleton [uiParagraph]="{ rows: 1, width: '100%' }" [uiTitle]="false" [uiActive]="true"> </ui-skeleton>
  </div>

  <div class="sub-description">
    <ui-skeleton [uiParagraph]="{ rows: 1, width: '100px' }" [uiTitle]="false"> </ui-skeleton>
  </div>

  <div class="owners-and-update-buttons">
    <div class="owners">
      <ui-skeleton-element *ngFor="let i of [1, 2, 3, 4, 5]" [uiActive]="true" uiSize="small" uiType="avatar"></ui-skeleton-element>
    </div>

    <div>
      <ui-skeleton [uiTitle]="false" [uiParagraph]="{ rows: 1, width: '121px' }" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-lg' }" [uiActive]="true"></ui-skeleton>
    </div>
  </div>

  <div>
    <ui-skeleton [uiTitle]="{ width: '76px' }" [uiSectionHeight]="{ title: 'h-md', paragraph: 'h-sm' }" [uiParagraph]="false" [uiActive]="true"></ui-skeleton>
  </div>

  <div class="time-filters">
    <ui-skeleton [uiTitle]="false" [uiParagraph]="{ rows: 1, width: '245px' }" [uiSectionHeight]="{ title: 'h-sm', paragraph: 'h-lg' }" [uiActive]="true"></ui-skeleton>
  </div>

  <div class="chart">
    <ui-skeleton-line [uiActive]="true" [style]="{ width: '685px', height: '500px', margin: '16px 0 0 0' }" />
  </div>

  <div class="statistics">
    <ui-skeleton-line *ngFor="let i of [1, 2, 3]" [uiActive]="true" [style]="{ width: '218px', height: '85px', margin: '16px 0 0 0' }" />
  </div>
</div>
